/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Derived rule status from the worst matched actor.
 */
export const SpendRuleUsageStatus = {
  Healthy: "healthy",
  Approaching: "approaching",
  Flagging: "flagging",
  Blocking: "blocking",
} as const;
/**
 * Derived rule status from the worst matched actor.
 */
export type SpendRuleUsageStatus = ClosedEnum<typeof SpendRuleUsageStatus>;

export type SpendRuleUsage = {
  /**
   * Total budgeted spend in USD (per-person limit times matched users).
   */
  budgetUsd: number;
  /**
   * Number of organization members the rule currently matches.
   */
  matchedUsers: number;
  /**
   * The budget rule ID.
   */
  ruleId: string;
  /**
   * Total spend in USD across matched users within the current window.
   */
  spendUsd: number;
  /**
   * Derived rule status from the worst matched actor.
   */
  status: SpendRuleUsageStatus;
  /**
   * Matched users at or past the limit.
   */
  usersBreached: number;
  /**
   * Matched users at or past the warning threshold but under the limit.
   */
  usersWarned: number;
  /**
   * Highest per-actor usage percentage across matched users (may exceed 100).
   */
  worstUsedPct: number;
};

/** @internal */
export const SpendRuleUsageStatus$inboundSchema: z.ZodMiniEnum<
  typeof SpendRuleUsageStatus
> = z.enum(SpendRuleUsageStatus);

/** @internal */
export const SpendRuleUsage$inboundSchema: z.ZodMiniType<
  SpendRuleUsage,
  unknown
> = z.pipe(
  z.object({
    budget_usd: z.number(),
    matched_users: z.int(),
    rule_id: z.string(),
    spend_usd: z.number(),
    status: SpendRuleUsageStatus$inboundSchema,
    users_breached: z.int(),
    users_warned: z.int(),
    worst_used_pct: z.number(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "budget_usd": "budgetUsd",
      "matched_users": "matchedUsers",
      "rule_id": "ruleId",
      "spend_usd": "spendUsd",
      "users_breached": "usersBreached",
      "users_warned": "usersWarned",
      "worst_used_pct": "worstUsedPct",
    });
  }),
);

export function spendRuleUsageFromJSON(
  jsonString: string,
): SafeParseResult<SpendRuleUsage, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SpendRuleUsage$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SpendRuleUsage' from JSON`,
  );
}
